<!-- TEMPLATE -->
<template>
  <div>
    <b-form-group>
      <b-form-radio
          v-if="!hideAsSoonAsPossibleOption"
          v-model="pickDate"
          value="no"
      >{{ asSoonAsPossibleLabel }}
      </b-form-radio>
      <b-form-radio
          v-model="pickDate"
          value="yes"
      >{{ pickDateLabel }}
      </b-form-radio>
      <CollapseTransition>
        <date-input
            :value="date"
            :min-date="productMinDate"
            :max-date="productMaxDate"
            :placeholder="label"
            :input-display-type="'column'"
            @dateValueChanged="wishDateValueChanged"
            v-if="pickDate === 'yes'"
        ></date-input>
      </CollapseTransition>
    </b-form-group>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
// VUE
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {
  BFormGroup,
  BFormRadio,
} from 'bootstrap-vue';
import DeanInputField from '@/components/deanComponents/deanInputField.vue';
import {CollapseTransition} from 'vue2-transitions';
import DateInput from '@/components/DateInput.vue';
import axios from 'axios';

@Component({
  components: {
    BFormRadio,
    BFormGroup,
    DeanInputField,
    CollapseTransition,
    DateInput,
  },
})

export default class WishDate extends Vue {
  @Prop() public label!: string;
  @Prop() public value!: string;
  @Prop() public productId!: string;
  @Prop() public selectedMobileNumberPorting!: boolean | null;
  @Prop({ default: false }) public hideAsSoonAsPossibleOption!: boolean;
  @Prop({ default: null }) public portingContractHandling!: string | null;
  public date: string = 'as_soon_as_possible_date';
  public pickDate: string = 'no';
  public asSoonAsPossibleDateValue: string = 'as_soon_as_possible_date';

  public asSoonAsPossibleLabel: string = 'Zo snel mogelijk';
  public pickDateLabel: string = 'Datum selecteren';
  private productMinDate: null | Date = null;
  private productMaxDate: null | Date = null;
  private mobileNumberPorting: boolean | null = false;

  public mounted() {
    this.initializeDate();
  }

  private initializeDate() {
    if (this.value && this.value !== this.asSoonAsPossibleDateValue) {
      this.pickDate = 'yes';
      this.date = new Date(this.value).toDateString();
    } else {
      this.pickDate = this.hideAsSoonAsPossibleOption ? 'yes' : 'no';
      if (!this.hideAsSoonAsPossibleOption) {
        this.$emit('input', this.asSoonAsPossibleDateValue);
      }
    }
  }

  @Watch('pickDate')
  @Watch('date')
  public update() {
    if (this.pickDate === 'no') {
      this.$emit('input', this.asSoonAsPossibleDateValue);
    } else {
      this.$emit('input', this.date);
    }
  }

  @Watch('hideAsSoonAsPossibleOption')
  private handleHideAsSoonAsPossibleOptionChange(newValue: boolean) {
    if (newValue && this.pickDate === 'no') {
      this.pickDate = 'yes';
    }
  }

  public created() {
    if (!this.hideAsSoonAsPossibleOption) {
      this.$emit('input', this.asSoonAsPossibleDateValue);
    }
  }

  @Watch('value', {immediate: true})
  public setDate() {
    if (
        this.value !== this.asSoonAsPossibleDateValue
        && this.value !== null
    ) {
      this.pickDate = 'yes';
      this.date = this.value;
    }
  }

  @Watch('selectedMobileNumberPorting')
  private getMobileNumberPorting() {
    this.mobileNumberPorting = this.selectedMobileNumberPorting;
  }

  @Watch('pickDate')
  @Watch('mobileNumberPorting')
  @Watch('portingContractHandling')
  private getMinAndMaxDateForProduct(): void {
    if (this.pickDate === 'yes') {
      axios
          .post('/-/trade/api/productWishDate.info', {
            productId: this.productId,
            mobilePortingNumber: this.mobileNumberPorting,
            portingContractHandling: this.portingContractHandling,
          })
          .then(
              (response: any) => {
                this.productMinDate = new Date(response.data.minDate);
                this.productMaxDate = new Date(response.data.maxDate);
              },
              (error: any) => {
                // tslint:disable-next-line:no-console
                console.error(error);
              },
          );
    }
  }

  private wishDateValueChanged(date: string | null): void {
    if (date !== null) {
      this.date = date;
    }
  }
}
</script>

<!-- STYLE -->

<style lang='scss' scoped>

</style>